// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__3Dt3R","clickable":"WidgetWrapper_clickable__Ehroe"};